import * as React from "react";
import CreateNewPasswordForm from "./newpassword/CreateNewPasswordForm";
import {none, option, Option} from "ts-option";
import * as queryString from "query-string";
import {RouteComponentProps, withRouter} from "react-router";
import {Dispatch} from "redux";
import {logOut} from "../../store/action/user/user";
import {connect} from "react-redux";
import {RootState} from "../../store/reducer/root/RootState";
import Settings from "../../model/settings/Settings";
import {isDefined} from "../../utils/Utils";
import Toast from "../helper/Toast";
import DrivingGreenLogo from "./DrivingGreenLogo";

interface IState {
	/**
	 * Rest password token.
	 */
	token: Option<string>
	roles: string[]
	showTechnicianSuccess: boolean
}

interface IDispatchProps {
	/**
	 * Log out user action.
	 */
	logOut: () => void;
}

interface IReduxProps {
	config: Option<Settings>
}

type Props = IDispatchProps & RouteComponentProps<{}> & IReduxProps;

class NewPasswordPage extends React.Component<Props, IState> {
	reactNativeWebView: any;

	constructor(props: Props) {
		super(props);
		const params = queryString.parse(props.location.search);
		const token = params["token"] as string;
		const roleParam = params["role"];
		const roles = Array.isArray(roleParam) ? roleParam.filter(isDefined) : (isDefined(roleParam) ? [roleParam] : []);
		this.state = {
			token: isDefined(token) ? option(token) : none,
			roles,
			showTechnicianSuccess: false
		};
		this.reactNativeWebView = (window as any).ReactNativeWebView;
		this.onSuccess = this.onSuccess.bind(this);
	}

	componentDidMount() {
		this.props.logOut();
	}

	render() {
		if (this.state.showTechnicianSuccess) {
			return (
				<div className={"c-new-password"}>
					<div className="c-new-password_content">
						<DrivingGreenLogo className="c-new-password_content_logo"/>
						<h1 className="c-new-password_content_header">You’re all set</h1>
						<p className="c-new-password_content_message">
							Your password has been set successfully.<br/>
							You can now log in using the mobile app.
						</p>
					</div>
				</div>
			);
		}

		return (
			<div className={"c-new-password"}>
				<div className="c-new-password_content">
					<DrivingGreenLogo className="c-new-password_content_logo"/>
					<h1 className="c-new-password_content_header">Set a new password</h1>
					<p className="c-new-password_content_intro">
						Choose a new password for your Driving Green account.
					</p>
					<CreateNewPasswordForm token={this.state.token.getOrElse("")} onSuccess={this.onSuccess}/>
					{!this.reactNativeWebView && !this.state.roles.includes("ORG_PARTNER_TECHNICIAN") && <div className={"c-new-password_content_link"}>
						<a href={this.props.config.map(cfg => cfg.resetPasswordRedirectUrl).getOrElse("/")}>Take me back to Sign In</a>
					</div>}
				</div>
			</div>
		);
	}

	onSuccess() {
		if (this.state.roles.includes("ORG_PARTNER_TECHNICIAN")) {
			this.setState({showTechnicianSuccess: true});
			return;
		}

		if (this.reactNativeWebView) {
			this.reactNativeWebView.postMessage(JSON.stringify({status: "success"}));
		}
		else {
			Toast.success("Password has been changed", "Password changed");
		}
		this.props.config.map(cfg => {
			window.location.replace(cfg.resetPasswordRedirectUrl);
		});
	}
}

function mapStateToProps(state: RootState) {
	return {
		config: state.settings.settings
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		logOut: () => dispatch(logOut())
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewPasswordPage));
